import React, { useState, useMemo } from "react";
import { Carousel, Modal } from "react-bootstrap";
import { useWebsite } from "../../../Context/WebSiteContext";

export default function GalleryModern({ config }) {
  const { formData } = useWebsite();
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const mergedConfig = useMemo(() => ({
    ...config,
    ...formData,
  }), [config, formData]);

  const imagens = mergedConfig?.galeria?.carouselImages || [];

  return (
    <section
      id="galeria"
      className="py-0"
      style={{
        backgroundColor: "#0b0b0b",
        height: "100vh",
        minHeight: "100vh",
        maxHeight: "100vh",
        overflow: "hidden"
      }}
    >
      <div className="w-100 h-100">
        <Carousel
          indicators={imagens.length > 1}
          controls={imagens.length > 1}
          fade
          className="h-100"
        >
          {imagens.map((imagem, index) => (
            <Carousel.Item key={index} className="h-100">
              <img
                src={imagem}
                alt={`Imagem ${index + 1}`}
                className="d-block w-100 h-100"
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                  maxHeight: "100vh",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setSelectedImage(imagem);
                  setShowModal(true);
                }}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Body className="p-0">
          <img
            src={selectedImage}
            alt="Imagem em destaque"
            style={{ width: "100%", height: "auto", borderRadius: "0.5rem" }}
          />
        </Modal.Body>
      </Modal>
    </section>
  );
}
